export default "__VITE_PUBLIC_ASSET__08f68af4__"